import React, { useState } from 'react';
import FarmRecordsTable from './FarmRecordsTable';
import FarmRecordsForm from './FarmRecordsForm';
import FarmRecordDetails from './FarmRecordDetails';

const FarmRecords = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [viewingRecord, setViewingRecord] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleAddNew = () => {
    setEditingRecord(null);
    setShowForm(true);
  };

  const handleEdit = (record) => {
    setEditingRecord(record);
    setShowForm(true);
  };

  const handleViewDetails = (record) => {
    setViewingRecord(record);
  };

  const handleFormSuccess = () => {
    setRefreshKey(prev => prev + 1);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditingRecord(null);
  };

  const handleCloseDetails = () => {
    setViewingRecord(null);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <FarmRecordsTable 
        key={refreshKey}
        onEdit={handleEdit} 
        onAddNew={handleAddNew}
        onViewDetails={handleViewDetails}
      />
      
      {showForm && (
        <FarmRecordsForm
          recordData={editingRecord}
          onClose={handleCloseForm}
          onSuccess={handleFormSuccess}
        />
      )}

      {viewingRecord && (
        <FarmRecordDetails
          record={viewingRecord}
          onClose={handleCloseDetails}
        />
      )}
    </div>
  );
};

export default FarmRecords; 